import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import MaterialIcon from '../../../../components/MaterialIcon';

const Entry = ({className, url, title, message, time}) => {
    const handleTap = useCallback(() => {
        window.Sentry.stashBreadcrumb('navigation', `Tapped on the banner with url=${url}`);
    }, [url]);

    return <a className={classNames('card', 'card-link', 'message', className)} href={url} onClick={handleTap}>
        <div className="card-content">
            <div className="icon">
                <MaterialIcon type="comment" large />
            </div>
            <div className="texts">
                <span className="card-title">{title}</span>
                <p>{message}</p>
            </div>
            {time && (
                <div className="time-remaining">
                    <span>{time}</span>
                </div>
            )}
        </div>
    </a>
};

Entry.propTypes = {
    className: PropTypes.string,
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    time: PropTypes.string,
};

Entry.defaultProps = {
    className: null,
    time: null,
};

export default Entry;



// WEBPACK FOOTER //
// ./scripts/frontend/questionnaires/components/Banner/Entry.js